import React from 'react';
import { Outlet } from 'react-router-dom';

const LogisticOutlet = () => {
  return (
    <>
        <Outlet />
    </>
  )
}

export default LogisticOutlet
